import React, { useState, useEffect } from 'react';
// パスを修正
import Loading from '../common/Loading';

// QRCodeScannerコンポーネントがなければ簡易実装
const QRCodeScanner = ({ onScanComplete }) => {
  return (
    <div className="qr-scanner">
      <p>QRコードスキャン機能 (モック)</p>
      <button onClick={() => onScanComplete('本店')}>
        スキャン完了（テスト用）
      </button>
    </div>
  );
};

const AttendancePage = () => {
  const [loading, setLoading] = useState(true);
  const [attendanceRecords, setAttendanceRecords] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showQRScanner, setShowQRScanner] = useState(false);
  const [currentStatus, setCurrentStatus] = useState(null); // 'clocked-in', 'clocked-out', or null

  // コンポーネントマウント時にデータを取得
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        // 実際の実装ではAPIコールを行う
        // 今回はモックデータでシミュレーション
        const userId = window.nekonoteData?.user_id || 1;
        const mockUser = {
          id: userId,
          name: 'ログインユーザー',
          type: '社員'
        };
        
        const mockAttendance = generateMockAttendance(userId);
        
        setCurrentUser(mockUser);
        setAttendanceRecords(mockAttendance);
        
        // ユーザーが現在出勤中かチェック
        const today = new Date().toDateString();
        const todaysRecords = mockAttendance.filter(record => 
          new Date(record.date).toDateString() === today
        );
        
        if (todaysRecords.length > 0) {
          const latestRecord = todaysRecords[todaysRecords.length - 1];
          if (latestRecord.clockOut === null) {
            setCurrentStatus('clocked-in');
          } else {
            setCurrentStatus('clocked-out');
          }
        } else {
          setCurrentStatus(null);
        }
        
        setLoading(false);
      } catch (error) {
        console.error('データ取得エラー:', error);
        setLoading(false);
      }
    };
    
    fetchData();
  }, []);

  // モック勤怠データを生成
  const generateMockAttendance = (userId) => {
    const records = [];
    const today = new Date();
    
    // 過去30日分のレコードを生成
    for (let i = 0; i < 30; i++) {
      const date = new Date();
      date.setDate(today.getDate() - i);
      
      // 一部の日をスキップしてより現実的に
      if (Math.random() > 0.7) continue;
      
      const startHour = 8 + Math.floor(Math.random() * 2);
      const startMinute = Math.floor(Math.random() * 30);
      const hoursWorked = 7 + Math.floor(Math.random() * 3);
      
      const clockInTime = new Date(date);
      clockInTime.setHours(startHour, startMinute, 0);
      
      let clockOutTime = null;
      // 過去の日付、または今日で既に退勤している場合のみ退勤時間を設定
      if (i > 0 || (i === 0 && Math.random() > 0.5)) {
        clockOutTime = new Date(date);
        clockOutTime.setHours(startHour + hoursWorked, startMinute + Math.floor(Math.random() * 30), 0);
      }
      
      records.push({
        id: `attendance-${date.toISOString()}-${userId}`,
        userId: userId,
        date: date,
        clockIn: clockInTime,
        clockOut: clockOutTime,
        status: clockOutTime ? 'completed' : 'active',
        location: '本店'
      });
    }
    
    return records.sort((a, b) => b.date - a.date);
  };

  // 出勤ボタンクリック処理
  const handleClockIn = () => {
    if (showQRScanner) {
      // QRコードスキャン中
      return;
    }
    
    setShowQRScanner(true);
  };

  // QRコードスキャン完了時の処理
  const handleQRScanComplete = (result) => {
    setShowQRScanner(false);
    
    // スキャン結果を処理して出勤を記録
    const newClockIn = {
      id: `attendance-${new Date().toISOString()}-${currentUser.id}`,
      userId: currentUser.id,
      date: new Date(),
      clockIn: new Date(),
      clockOut: null,
      status: 'active',
      location: result || '本店'
    };
    
    setAttendanceRecords(prev => [newClockIn, ...prev]);
    setCurrentStatus('clocked-in');
    
    // 実際の実装ではAPIコールを行う
    alert('出勤が記録されました。');
  };

  // 退勤ボタンクリック処理
  const handleClockOut = () => {
    // 今日のアクティブな勤怠記録を検索
    const today = new Date().toDateString();
    const todaysRecordIndex = attendanceRecords.findIndex(record => 
      new Date(record.date).toDateString() === today && record.status === 'active'
    );
    
    if (todaysRecordIndex === -1) {
      alert('本日の出勤記録が見つかりません。');
      return;
    }
    
    // 退勤時間で記録を更新
    const updatedRecords = [...attendanceRecords];
    updatedRecords[todaysRecordIndex] = {
      ...updatedRecords[todaysRecordIndex],
      clockOut: new Date(),
      status: 'completed'
    };
    
    setAttendanceRecords(updatedRecords);
    setCurrentStatus('clocked-out');
    
    // 実際の実装ではAPIコールを行う
    alert('退勤が記録されました。');
  };

  // 日付表示用フォーマット
  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('ja-JP', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  };

  // 時間表示用フォーマット
  const formatTime = (date) => {
    if (!date) return '--:--';
    return new Date(date).toLocaleTimeString('ja-JP', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // 出勤から退勤までの時間を計算
  const calculateDuration = (clockIn, clockOut) => {
    if (!clockIn || !clockOut) return '--:--';
    
    const start = new Date(clockIn);
    const end = new Date(clockOut);
    const durationMs = end - start;
    
    // 時間と分に変換
    const hours = Math.floor(durationMs / (1000 * 60 * 60));
    const minutes = Math.floor((durationMs % (1000 * 60 * 60)) / (1000 * 60));
    
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  };

  // 勤怠履歴表示の日付選択処理
  const handleDateChange = (e) => {
    setSelectedDate(new Date(e.target.value));
  };

  // 選択された日付に基づいて記録をフィルタリング
  const getFilteredRecords = () => {
    const year = selectedDate.getFullYear();
    const month = selectedDate.getMonth();
    
    return attendanceRecords.filter(record => {
      const recordDate = new Date(record.date);
      return recordDate.getFullYear() === year && recordDate.getMonth() === month;
    });
  };

  if (loading) {
    return <Loading />;
  }

  const filteredRecords = getFilteredRecords();

  return (
    <div className="attendance-page">
      <h2>勤怠管理</h2>
      <p>勤怠の記録、確認ができます</p>
      
      <div className="attendance-controls">
        <div className="clock-buttons">
          <button 
            className={`clock-in-btn ${currentStatus === 'clocked-in' ? 'disabled' : ''}`}
            onClick={handleClockIn}
            disabled={currentStatus === 'clocked-in'}
          >
            出勤
          </button>
          <button 
            className={`clock-out-btn ${currentStatus !== 'clocked-in' ? 'disabled' : ''}`}
            onClick={handleClockOut}
            disabled={currentStatus !== 'clocked-in'}
          >
            退勤
          </button>
        </div>
        
        {showQRScanner && (
          <div className="qr-scanner-container">
            <div className="qr-scanner-overlay">
              <div className="qr-scanner-header">
                <h3>QRコードをスキャン</h3>
                <button onClick={() => setShowQRScanner(false)}>閉じる</button>
              </div>
              <QRCodeScanner onScanComplete={handleQRScanComplete} />
              <p className="qr-instructions">店舗に設置されたQRコードをスキャンしてください</p>
            </div>
          </div>
        )}
      </div>
      
      <div className="attendance-history">
        <h3>勤怠履歴</h3>
        
        <div className="date-filter">
          <label>
            表示する月:
            <input 
              type="month" 
              value={`${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}`}
              onChange={handleDateChange}
            />
          </label>
        </div>
        
        <div className="attendance-table-container">
          <table className="attendance-table">
            <thead>
              <tr>
                <th>日付</th>
                <th>出勤時間</th>
                <th>退勤時間</th>
                <th>勤務時間</th>
                <th>勤務場所</th>
                <th>状態</th>
              </tr>
            </thead>
            <tbody>
              {filteredRecords.length > 0 ? (
                filteredRecords.map(record => (
                  <tr key={record.id}>
                    <td>{formatDate(record.date)}</td>
                    <td>{formatTime(record.clockIn)}</td>
                    <td>{formatTime(record.clockOut)}</td>
                    <td>{calculateDuration(record.clockIn, record.clockOut)}</td>
                    <td>{record.location}</td>
                    <td>
                      <span className={`status-badge ${record.status}`}>
                        {record.status === 'active' ? '勤務中' : '完了'}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="no-records">この月の勤怠記録はありません</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      
      <div className="attendance-summary">
        <h3>今月の集計</h3>
        <div className="summary-stats">
          <div className="summary-item">
            <span className="summary-label">勤務日数</span>
            <span className="summary-value">{filteredRecords.length}日</span>
          </div>
          <div className="summary-item">
            <span className="summary-label">総勤務時間</span>
            <span className="summary-value">
              {(() => {
                let totalMinutes = 0;
                filteredRecords.forEach(record => {
                  if (record.clockIn && record.clockOut) {
                    totalMinutes += (new Date(record.clockOut) - new Date(record.clockIn)) / (1000 * 60);
                  }
                });
                const hours = Math.floor(totalMinutes / 60);
                const minutes = Math.floor(totalMinutes % 60);
                return `${hours}時間${minutes}分`;
              })()}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendancePage;
